<template>
    <q-dialog v-model="display">
        <q-card style="min-width: 350px">
            <q-card-section>
                <div class="text-h6">{{$t('send_more_get_better_rates')}}</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <q-list bordered separator >
                    <q-item v-for="tier in ramp.tiers" :key="tier.amount">
                        <q-item-section>
                            <q-item-label>{{ tier.amount === 0 ? $t('calculator.standard_rate') : $t('calculator.above') + ' ' + tier.amount + ' ' + ramp.from.symbol }}</q-item-label>
                        </q-item-section>

                        <q-item-section>
                            <q-item-label dir="ltr">
                                <currency-format :value="1"
                                                 hide-zero-decimal
                                                 hide-white-spaces
                                                 style="display:inline-block"
                                                 :unit="displayable_origin_symbol"
                                />
                                =
                                <currency-format :value="roundRate(tier.rate)"
                                                 hide-zero-decimal
                                                 hide-white-spaces
                                                 style="display:inline-block"
                                                 :unit="displayable_dest_symbol"
                                />
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-card-section>

            <q-card-actions align="right" class="bg-white text-primary">
                <q-btn flat :label="$t('ok')" v-close-popup/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import {mapGetters} from 'vuex'
export default {
    name: "DiscountRulesDialog",
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        ramp: {
            type: Object,
            default: {}
        },
        rateReversed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['exchange_rates']),
        display: {
            get: function () {
                return this.show
            },
            set: function (value) {
                this.$emit('change', value)
            }
        },
        from_currency() {
            return this.ramp.from
        },
        to_currency() {
            return this.ramp.to
        },
        displayable_origin_symbol() {
            return this.rateReversed ? this.to_currency.symbol : this.from_currency.symbol
        },
        displayable_dest_symbol() {
            return this.rateReversed ? this.from_currency.symbol : this.to_currency.symbol
        },
    },
    data() {
        return {}
    },
    methods: {
        roundRate(rate) {
            return Number((this.rateReversed) ? (1 / rate) : rate).roundToX(this.ramp.decimals)
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
